'use client';

import React, { useEffect, useState } from 'react';
import ActivityCard from './ActivityCard';
import { ActivityPoint } from './HeatMap';
import LearningStats from './LearningStats';
import QuizzStats from './QuizzStats';

const Stats = () => {
  const [eventCount, setEventCount] = useState(0);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [activity, setActivity] = useState<ActivityPoint[]>([]);

  useEffect(() => {
    async function getActivity() {
      const res = await fetch(`/api/get-activity`);

      if (!res.ok) {
        console.log(res.statusText);
        return;
      }
      const { streak, activity, eventCount } = await res.json();

      setEventCount(eventCount);
      setCurrentStreak(streak);
      setActivity(activity);
    }
    getActivity();
  }, []);

  return (
    <div className="mt-12 w-full space-y-4 pb-12 sm:mt-4 sm:space-y-8">
      <ActivityCard
        eventCount={eventCount}
        currentStreak={currentStreak}
        activity={activity}
      />
      <QuizzStats />
      <LearningStats />
    </div>
  );
};

export default Stats;
